// tslint:disable-next-line:no-var-requires
require("es6-promise").polyfill()
require("isomorphic-fetch")
import Http from "./http"
import IApplicationVm from "../models/shared/IApplicationVm"
import ICitizenVm from "../models/shared/ICitizenVm"
import ICompanyVm from "../models/shared/ICompanyVm"
import * as moment from "moment"
import { CertificateProcessType } from "../models/flags/CertificateProcessType"
import IPhotoCropVm from "../models/home/PhotoCrop/IPhotoCropVm"
import IVisitationExpireDateComparisonVm from "../models/citizen/IVisitationExpireDateComparisonVm"
import IImageVm from "../models/home/PhotoCrop/IImageVm"
import { ApplicationSubmitStatusType } from "../models/enums/ApplicationSubmitStatusType"
import ICreateApplicationForExemptedCitizenVm from "../models/issuingAuthority/ICreateApplicationForExemptedCitizenVm"
import ICitizenForApplicationForExemptedCitizenVm from "../models/issuingAuthority/ICitizenForApplicationForExemptedCitizenVm"
import ICreateApplicationForReorderingOfCertificateVm from "../models/issuingAuthority/ICreateApplicationForReorderingOfCertificateVm"
import { CertificateType } from "../models/flags/CertificateType"
import ITeamVm from "../models/shared/ITeamVm"
import IApplicationBaseSearchVm from "../models/shared/IApplicationBaseSearchVm"
import IErrorCaseSearchVm from "../models/issuingAuthority/IErrorCaseSearchVm"
import IErrorCaseVm from "../models/issuingAuthority/IErrorCaseVm"
import { ErrorCaseStatusType } from "../models/enums/ErrorCaseStatusType"
import IBulkInvoiceSearchVm from "../models/shared/IBulkInvoiceSearchVm"
import { IApplicationSearchObject } from "../components/SearchApplications/SearchBox"
import { ApplicationStatusType } from "../models/enums/ApplicationStatusType"
import { IBulkInvoiceSearchObject, IErrorCaseSearchObject } from "../reducers/metaReducer"
import ICommentVm from "../models/shared/ICommentVm"
import IParentBulkInvoiceVm from "../models/home/Payment/IParentBulkInvoiceVm"
import { ApplicationEventType } from "../models/enums/ApplicationEventType"
import IPreviousApplicationForAdrVm from "../models/educationalInstitution/IPreviousApplicationForAdrVm"

export default class Api {
    public static company = {
        async getCompanyFromCvr(cvr: string, invoiceId: string): Promise<ICompanyVm> {
            return await Http.get<ICompanyVm>("Company/GetCompanyFromCvr?cvr=" + cvr + "&invoiceId=" + invoiceId)
        },
    }

    public static issuingAuthorityCaseworker = {
        async approveApplicationForTax(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("IssuingAuthority/ApplicationForTax/ApproveApplicationForTax", application)
        },
        async rejectApplicationForTax(applicationId: string): Promise<IApplicationVm> {
            return await Http.post<any, IApplicationVm>("IssuingAuthority/ApplicationForTax/RejectApplicationForTax", { applicationId })
        },
        async submitOnBehalfOfCitizen(application: IApplicationVm){
            return await Http.post<any, IApplicationVm>("IssuingAuthority/ApplicationForTax/SubmitApplicationOnBehalfOfCitizen", application)
        },
        async returnApplicationForTaxForResubmittal(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("IssuingAuthority/ApplicationForTax/ReturnApplicationForTaxForResubmittal", application)
        },
        async saveApplicationForTax(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("IssuingAuthority/ApplicationForTax/SaveApplicationForTax", application)
        },
        async saveApplicationForVub(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("IssuingAuthority/ApplicationForVub/SaveApplicationForVub", application)
        },
        async saveApplicationForCub(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("IssuingAuthority/ApplicationForCub/SaveApplicationForCub", application)
        },
        async saveApplicationForSta(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("IssuingAuthority/ApplicationForSta/SaveApplicationForSta", application)
        },
        async saveApplicationForAdr(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("IssuingAuthority/ApplicationForAdr/SaveApplicationForAdr", application)
        },
        async searchApplications(
            sortProperty: string,
            isSortAsc: boolean,
            pageNumber: number,
            applicationSearchObject: IApplicationSearchObject): Promise<IApplicationBaseSearchVm> {
            const queryStringParams = await Api.buildApplicationSearchQuery(
                sortProperty,
                isSortAsc,
                pageNumber,
                applicationSearchObject.civilRegistrationIdentifier,
                applicationSearchObject.certificateNumber,
                applicationSearchObject.name,
                applicationSearchObject.certificateType,
                applicationSearchObject.certificateProcessType,
                applicationSearchObject.applicationStatus,
                applicationSearchObject.isApplicationSubmittetByEducationalInstitution,
                applicationSearchObject.isApplicationSubmittetByCitizen,
                applicationSearchObject.invoiceNumber,
                applicationSearchObject.educationalInstitutionId,
                null,
                null,
                applicationSearchObject.applicationEventType,
                applicationSearchObject.applicationEventTypeDateFrom,
                applicationSearchObject.applicationEventTypeDateTo
            )
            return await Http.get<IApplicationBaseSearchVm>("Shared/Search/SearchApplications?" + queryStringParams)
        },
        async saveCommentOnApplicationAndJournalize(comment: ICommentVm): Promise<ICommentVm> {
            return await Http.post<ICommentVm>("IssuingAuthority/ApplicationShared/SaveCommentOnApplicationAndJournalize", comment)
        }
    }

    public static IssuingAuthorityAdministrativeCaseWorker = {
        async createApplicationForExemptedCitizen(applicationForExempted: ICreateApplicationForExemptedCitizenVm): Promise<ICreateApplicationForExemptedCitizenVm> {
            return await Http.post<ICreateApplicationForExemptedCitizenVm>("IssuingAuthority/ApplicationShared/CreateApplicationForExemptedCitizen", applicationForExempted)
        },
        async createApplicationForReorderingOfCertificate(createApplicationForReorderingOfCertificate: ICreateApplicationForReorderingOfCertificateVm): Promise<ICreateApplicationForReorderingOfCertificateVm> {
            switch (createApplicationForReorderingOfCertificate.certificateType) {
                case CertificateType.Tax:
                    return await Http.post<ICreateApplicationForReorderingOfCertificateVm>("IssuingAuthority/ApplicationForTax/CreateApplicationForReorderingOfCertificate", createApplicationForReorderingOfCertificate)
                case CertificateType.Cub:
                    return await Http.post<ICreateApplicationForReorderingOfCertificateVm>("IssuingAuthority/ApplicationForCub/CreateApplicationForReorderingOfCertificate", createApplicationForReorderingOfCertificate)
                case CertificateType.Sta:
                    return await Http.post<ICreateApplicationForReorderingOfCertificateVm>("IssuingAuthority/ApplicationForSta/CreateApplicationForReorderingOfCertificate", createApplicationForReorderingOfCertificate)
                case CertificateType.Vub:
                    return await Http.post<ICreateApplicationForReorderingOfCertificateVm>("IssuingAuthority/ApplicationForVub/CreateApplicationForReorderingOfCertificate", createApplicationForReorderingOfCertificate)
                case CertificateType.Adr:
                    return await Http.post<ICreateApplicationForReorderingOfCertificateVm>("IssuingAuthority/ApplicationForAdr/CreateApplicationForReorderingOfCertificate", createApplicationForReorderingOfCertificate)
                default:
                    return undefined
            }
        },
        async getCitizenForCreateApplicationForExempted(civilRegistrationIdentifier: string): Promise<ICitizenForApplicationForExemptedCitizenVm> {
            return await Http.get<ICitizenForApplicationForExemptedCitizenVm>("IssuingAuthority/ApplicationShared/GetCitizenForCreateApplicationForExempted?civilRegistrationIdentifier=" + civilRegistrationIdentifier)
        },
        async createNewApplicationBasedOnErrornousApplication(application: IApplicationVm): Promise<IApplicationVm> {
            switch (application.certificateType) {
                case CertificateType.Cub:
                    return await Http.post<IApplicationVm>("IssuingAuthority/ApplicationForCub/CreateNewApplicationBasedOnErrornousApplication", application)
                case CertificateType.Sta:
                    return await Http.post<IApplicationVm>("IssuingAuthority/ApplicationForSta/CreateNewApplicationBasedOnErrornousApplication", application)
                case CertificateType.Vub:
                    return await Http.post<IApplicationVm>("IssuingAuthority/ApplicationForVub/CreateNewApplicationBasedOnErrornousApplication", application)
                case CertificateType.Adr:
                    return await Http.post<IApplicationVm>("IssuingAuthority/ApplicationForAdr/CreateNewApplicationBasedOnErrornousApplication", application)
                default:
                    return undefined
            }
        },
        async cancelCertificateDueToErrorsOnCertificate(applicationId: string): Promise<IApplicationVm> {
            return await Http.post<any, IApplicationVm>("IssuingAuthority/ApplicationShared/CancelCertificateDueToErrorsOnCertificate", { applicationId })
        },
        async cancelApplicationDueToErrorsInApplication(applicationId: string): Promise<IApplicationVm> {
            return await Http.post<any, IApplicationVm>("IssuingAuthority/ApplicationShared/CancelApplicationDueToErrorsInApplication", { applicationId })
        },
        async revokeCertificate(applicationId: string): Promise<IApplicationVm> {
            return await Http.post<any, IApplicationVm>("IssuingAuthority/ApplicationShared/RevokeCertificate", { applicationId })
        },
        async reactivateRevokedCertificate(applicationId: string): Promise<IApplicationVm> {
            return await Http.post<any, IApplicationVm>("IssuingAuthority/ApplicationShared/ReactivateRevokedCertificate", { applicationId })
        }
    }

    public static citizen = {
        async getVisitationExpireDateResult(expireDate: string): Promise<IVisitationExpireDateComparisonVm> {
            return await Http.get<IVisitationExpireDateComparisonVm>("Citizen/ApplicationForTax/GetVisitationExpireDateResult?expireDate=" + expireDate)
        },
        async isTypedInDiplomaIssueDateToFarIntoThePast(issueDate: string): Promise<string> {
            return await Http.get<string>("Citizen/ApplicationForTax/IsTypedInDiplomaIssueDateToFarIntoThePast?issueDate=" + issueDate)
        },
        async resubmitApplicationForTax(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/ResubmitApplicationForTax", application)
        },
        async saveApplicationForTax(application: IApplicationVm): Promise<IApplicationVm> {
            if (application.applicationSubmittetByCitizenStatus === ApplicationSubmitStatusType.NotSubmitted ||
                application.applicationSubmittetByCitizenStatus === ApplicationSubmitStatusType.NotSet) {
                switch (application.certificateProcessType) {
                    case CertificateProcessType.Issuing:
                        return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/SaveApplicationForTaxIssuing", application)
                    case CertificateProcessType.Renewal:
                        return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/SaveApplicationForTaxRenewal", application)
                    case CertificateProcessType.Change:
                        return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/SaveApplicationForTaxChange", application)
                    case CertificateProcessType.Replacement:
                        return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/SaveApplicationForTaxReplacement", application)
                    case CertificateProcessType.RenewalBasedOnExternal:
                        return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/SaveApplicationForTaxRenewalBasedOnExternal", application)
                    case CertificateProcessType.ChangeBasedOnExternal:
                        return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/SaveApplicationForTaxChangeBasedOnExternal", application)
                    case CertificateProcessType.ReplacementBasedOnExternal:
                        return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/SaveApplicationForTaxReplacementBasedOnExternal", application)
                }
            } else if (application.applicationSubmittetByCitizenStatus === ApplicationSubmitStatusType.NeedsResubmittal) {
                switch (application.certificateProcessType) {
                    case CertificateProcessType.Renewal:
                        return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/SaveApplicationForTaxResubmitRenewal", application)
                    case CertificateProcessType.RenewalBasedOnExternal:
                        return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/SaveApplicationForTaxResubmitRenewalBasedOnExternal", application)
                    case CertificateProcessType.ChangeBasedOnExternal:
                        return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/SaveApplicationForTaxResubmitChangeBasedOnExternal", application)
                    case CertificateProcessType.ReplacementBasedOnExternal:
                        return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/SaveApplicationForTaxResubmitReplacementBasedOnExternal", application)
                }
            }

            return undefined
        },
        async saveApplicationForVub(application: IApplicationVm): Promise<IApplicationVm> {
            switch (application.certificateProcessType) {
                case CertificateProcessType.Replacement:
                    return await Http.post<IApplicationVm>("Citizen/ApplicationForVub/SaveApplicationForVubReplacement", application)
                default: return undefined
            }
        },
        async saveApplicationForCub(application: IApplicationVm): Promise<IApplicationVm> {
            switch (application.certificateProcessType) {
                case CertificateProcessType.Replacement:
                    return await Http.post<IApplicationVm>("Citizen/ApplicationForCub/SaveApplicationForCubReplacement", application)
                default: return undefined
            }
        },
        async saveApplicationForSta(application: IApplicationVm): Promise<IApplicationVm> {
            switch (application.certificateProcessType) {
                case CertificateProcessType.Replacement:
                    return await Http.post<IApplicationVm>("Citizen/ApplicationForSta/SaveApplicationForStaReplacement", application)
                default: return undefined
            }
        },
        async saveApplicationForAdr(application: IApplicationVm): Promise<IApplicationVm> {
            switch (application.certificateProcessType) {
                case CertificateProcessType.Replacement:
                    return await Http.post<IApplicationVm>("Citizen/ApplicationForAdr/SaveApplicationForAdrReplacement", application)
                default: return undefined
            }
        },
        async submitApplicationForTax(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("Citizen/ApplicationForTax/SubmitApplicationForTax", application)
        },
        async submitApplicationForVub(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("Citizen/ApplicationForVub/SubmitApplicationForVub", application)
        },
        async submitApplicationForCub(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("Citizen/ApplicationForCub/SubmitApplicationForCub", application)
        },
        async submitApplicationForSta(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("Citizen/ApplicationForSta/SubmitApplicationForSta", application)
        },
        async submitApplicationForAdr(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("Citizen/ApplicationForAdr/SubmitApplicationForAdr", application)
        },
    }

    public static educationalInstitution = {
        async saveApplicationForTax(application: IApplicationVm): Promise<IApplicationVm> {
            return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForTax/SaveApplicationForTaxIssuing", application)
        },
        async submitApplicationForTax(applicationid: string): Promise<IApplicationVm> {
            return await Http.post<any, IApplicationVm>("EducationalInstitution/ApplicationForTax/SubmitApplicationForTax", { applicationid })
        },
        async lookupCivilRegistrationIdentifier(civilRegistrationIdentifier: string, certificateType: CertificateType): Promise<ICitizenVm | IApplicationVm> {
            return await Http.get<ICitizenVm | IApplicationVm>("EducationalInstitution/Citizen/LookupCivilRegistrationIdentifier?civilRegistrationIdentifier=" + civilRegistrationIdentifier + "&certificateType=" + certificateType)
        },
        async searchApplications(
            sortProperty: string,
            isSortAsc: boolean,
            pageNumber: number,
            applicationSearchObject: IApplicationSearchObject): Promise<IApplicationBaseSearchVm> {
            const queryStringParams = await Api.buildApplicationSearchQuery(
                sortProperty,
                isSortAsc,
                pageNumber,
                applicationSearchObject.civilRegistrationIdentifier,
                applicationSearchObject.certificateNumber,
                applicationSearchObject.name,
                applicationSearchObject.certificateType,
                null,
                applicationSearchObject.applicationStatus,
                applicationSearchObject.isApplicationSubmittetByEducationalInstitution,
                null,
                null,
                null,
                applicationSearchObject.teamId,
                applicationSearchObject.companyId,
                applicationSearchObject.applicationEventType,
                applicationSearchObject.applicationEventTypeDateFrom,
                applicationSearchObject.applicationEventTypeDateTo
            )
            return await Http.get<IApplicationBaseSearchVm>("Shared/Search/SearchApplications?" + queryStringParams)
        },
        async resubmitApplicationForTax(applicationId: string): Promise<IApplicationVm> {
            return await Http.post<any, IApplicationVm>("EducationalInstitution/ApplicationForTax/ResubmitApplicationForTax", { applicationId })
        },
        async createOrUpdateTeam(team: ITeamVm): Promise<ITeamVm> {
            return await Http.post<ITeamVm>("EducationalInstitution/Team/CreateOrUpdateTeam", team)
        },
        async getCountOfNonSubmittedApplicationsOnTeam(teamId: string): Promise<number> {
            return await Http.get<number>("EducationalInstitution/Team/GetCountOfNonSubmittedApplicationsOnTeam?teamId=" + teamId, false)
        },
        async getCountOfNonSubmittedApplicationsWithCompanyChosenForPayment(companyChosenForPaymentId: string): Promise<number> {
            return await Http.get<number>("EducationalInstitution/Company/GetCountOfNonSubmittedApplicationsWithCompanyChosenForPayment?companyChosenForPaymentId=" + companyChosenForPaymentId, false)
        },
        async saveApplicationForVub(application: IApplicationVm): Promise<IApplicationVm> {
            switch (application.certificateProcessType) {
                case CertificateProcessType.Issuing:
                    return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForVub/SaveApplicationForVubIssuing", application)
                case CertificateProcessType.Change:
                    return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForVub/SaveApplicationForVubChange", application)
                case CertificateProcessType.Replacement:
                    return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForVub/SaveApplicationForVubReplacement", application)
                default:
                    return undefined
            }
        },
        async saveApplicationForCub(application: IApplicationVm): Promise<IApplicationVm> {
            switch (application.certificateProcessType) {
                case CertificateProcessType.Issuing:
                    return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForCub/SaveApplicationForCubIssuing", application)
                case CertificateProcessType.Change:
                    return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForCub/SaveApplicationForCubChange", application)
                case CertificateProcessType.Replacement:
                    return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForCub/SaveApplicationForCubReplacement", application)
                default:
                    return undefined
            }
        },
        async saveApplicationForSta(application: IApplicationVm): Promise<IApplicationVm> {
            switch (application.certificateProcessType) {
                case CertificateProcessType.Issuing:
                    return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForSta/SaveApplicationForStaIssuing", application)
                case CertificateProcessType.Change:
                    return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForSta/SaveApplicationForStaChange", application)
                case CertificateProcessType.Replacement:
                    return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForSta/SaveApplicationForStaReplacement", application)
                default:
                    return undefined
            }
        },
        async saveApplicationForAdr(application: IApplicationVm): Promise<IApplicationVm> {
            switch (application.certificateProcessType) {
                case CertificateProcessType.Issuing:
                    return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForAdr/SaveApplicationForAdrIssuing", application)
                case CertificateProcessType.Change:
                    return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForAdr/SaveApplicationForAdrChange", application)
                case CertificateProcessType.Replacement:
                    return await Http.post<IApplicationVm>("EducationalInstitution/ApplicationForAdr/SaveApplicationForAdrReplacement", application)
                default:
                    return undefined
            }
        },
        async submitAndApproveApplicationForVub(applicationId: string): Promise<IApplicationVm> {
            return await Http.post<any, IApplicationVm>("EducationalInstitution/ApplicationForVub/SubmitAndApproveApplicationForVub", { applicationId })
        },
        async submitAndApproveApplicationForCub(applicationId: string): Promise<IApplicationVm> {
            return await Http.post<any, IApplicationVm>("EducationalInstitution/ApplicationForCub/SubmitAndApproveApplicationForCub", { applicationId })
        },
        async submitAndApproveApplicationForSta(applicationId: string): Promise<IApplicationVm> {
            return await Http.post<any, IApplicationVm>("EducationalInstitution/ApplicationForSta/SubmitAndApproveApplicationForSta", { applicationId })
        },
        async submitAndApproveApplicationForAdr(applicationId: string): Promise<IApplicationVm> {
            return await Http.post<any, IApplicationVm>("EducationalInstitution/ApplicationForAdr/SubmitAndApproveApplicationForAdr", { applicationId })
        },
        async findPreviousApplicationForAdr(civilRegistrationIdentifier: string): Promise<IPreviousApplicationForAdrVm | null> {
            return await Http.get<IPreviousApplicationForAdrVm | null>("EducationalInstitution/ApplicationForAdr/FindPreviousApplication?civilRegistrationIdentifier=" + civilRegistrationIdentifier);
        },
        async markCompanyAsNonActive(company: ICompanyVm): Promise<ICompanyVm> {
            return await Http.post<any, ICompanyVm>("EducationalInstitution/Company/MarkCompanyAsNonActive", { companyId: company.id })
        },
        async searchBulkInvoices(sortProperty: string, isSortAsc: boolean, pageNumber: number, bulkInvoiceSearchObject: IBulkInvoiceSearchObject, useAsyncMarker: boolean): Promise<IBulkInvoiceSearchVm> {
            const queryStringParams = await Api.buildBulkInvoiceSearchQuery(sortProperty, isSortAsc, pageNumber, bulkInvoiceSearchObject)
            return await Http.get<IBulkInvoiceSearchVm>("Shared/Search/SearchBulkInvoices?" + queryStringParams, useAsyncMarker)
        },
        async searchApplicationsForBulkPayments(sortProperty: string, isSortAsc: boolean, pageNumber: number, bulkInvoiceSearchObject: IBulkInvoiceSearchObject, useAsyncMarker: boolean): Promise<IApplicationBaseSearchVm> {
            const queryStringParams = await Api.buildApplicationsForBulkPaymentsSearchQuery(sortProperty, isSortAsc, pageNumber, bulkInvoiceSearchObject)
            return await Http.get<IApplicationBaseSearchVm>("Shared/Search/SearchApplicationsForBulkPayments?" + queryStringParams, useAsyncMarker)
        }
    }

    public static photo = {
        async findCropBox(base64Image: string): Promise<IPhotoCropVm> {
            return await Http.post<any, IPhotoCropVm>("PhotoCrop/FindCropBox", { base64: base64Image })
        },
        async rotateImage90DegreesClockwise(base64Image: string): Promise<IImageVm> {
            return await Http.post<any, IImageVm>("PhotoCrop/RotateImage90DegreesClockwise", { base64: base64Image })
        }
    }

    public static shared = {
        async getApplication(certificateType: CertificateType, applicationId: string): Promise<IApplicationVm> {
            switch (certificateType) {
                case CertificateType.Tax:
                    return await Http.get<IApplicationVm>("Shared/ApplicationForTax/GetApplication?applicationId=" + applicationId)
                case CertificateType.Cub:
                    return await Http.get<IApplicationVm>("Shared/ApplicationForCub/GetApplication?applicationId=" + applicationId)
                case CertificateType.Sta:
                    return await Http.get<IApplicationVm>("Shared/ApplicationForSta/GetApplication?applicationId=" + applicationId)
                case CertificateType.Vub:
                    return await Http.get<IApplicationVm>("Shared/ApplicationForVub/GetApplication?applicationId=" + applicationId)
                case CertificateType.Adr:
                    return await Http.get<IApplicationVm>("Shared/ApplicationForAdr/GetApplication?applicationId=" + applicationId)
                default:
                    return undefined
            }
        },
        async lookupElectronicInvoiceNumber(electronicInvoiceNumber: string): Promise<ICompanyVm> {
            return await Http.get<ICompanyVm>("Shared/Payment/LookupElectronicInvoiceNumber?electronicInvoiceNumber=" + electronicInvoiceNumber)
        },
        async createCompanyForOnlinePaymentOrElectronicInvoice(company: ICompanyVm): Promise<ICompanyVm> {
            return await Http.post<ICompanyVm>("Shared/Payment/CreateCompanyForOnlinePaymentOrElectronicInvoice", company)
        },
        async lookupCompanyRegistrationIdentifier(companyRegistrationIdentifier: string): Promise<ICompanyVm> {
            return await Http.get<ICompanyVm>("Shared/Payment/LookupCompanyRegistrationIdentifier?companyRegistrationIdentifier=" + companyRegistrationIdentifier)
        },
        async issueBulkPaymentDemand(parentBulkPaymentId: string): Promise<IParentBulkInvoiceVm> {
            return await Http.post<any, IParentBulkInvoiceVm>("Shared/Payment/IssueBulkPaymentDemand", { parentBulkPaymentId })
        },
        async markApplicationAsDeleted(applicationId: string): Promise<IApplicationVm> {
            return await Http.post<any, IApplicationVm>("Shared/ApplicationBase/MarkApplicationAsDeleted", { applicationId })
        },
        async getCitizenFromCivilRegister(civilRegistrationIdentifier: string): Promise<ICitizenVm> {
            return await Http.get<ICitizenVm>("Shared/Citizen/GetCitizenFromCivilRegister?civilRegistrationIdentifier=" + civilRegistrationIdentifier)
        },
        async getApplicationReceiptHtml(receiptId: string): Promise<string> {
            return await Http.get<string>("Shared/ApplicationReceipt/GetApplicationReceiptHtml?receiptId=" + receiptId)
        },
        downloadReceipt(receiptId: string) {
            return process.env.SERVER + "Shared/ApplicationReceipt/DownloadReceipt?receiptId=" + receiptId
        }
    }

    public static errorCase = {
        async searchErrorCases(sortProperty: string, isSortAsc: boolean, pageNumber: number, errorCaseSearchObject: IErrorCaseSearchObject): Promise<IErrorCaseSearchVm> {
            const queryStringParams = await Api.buildErrorCaseSearchQuery(sortProperty, isSortAsc, pageNumber, errorCaseSearchObject)
            return await Http.get<IErrorCaseSearchVm>("IssuingAuthority/ErrorCase/SearchErrorCases?" + queryStringParams)
        },
        async takeErrorCase(id: string): Promise<IErrorCaseVm> {
            return await Http.post<any, IErrorCaseVm>("IssuingAuthority/ErrorCase/TakeErrorCase", { errorCaseId: id })
        },
        async releaseErrorCase(id: string): Promise<IErrorCaseVm> {
            return await Http.post<any, IErrorCaseVm>("IssuingAuthority/ErrorCase/ReleaseErrorCase", { errorCaseId: id })
        },
        async resolveErrorCase(id: string, errorCaseStatus: ErrorCaseStatusType): Promise<IErrorCaseVm> {
            return await Http.post<any, IErrorCaseVm>("IssuingAuthority/ErrorCase/ResolveErrorCase", { errorCaseId: id, SolvedStatus: errorCaseStatus })
        },
        async reopenErrorCase(id: string): Promise<IErrorCaseVm> {
            return await Http.post<any, IErrorCaseVm>("IssuingAuthority/ErrorCase/ReopenErrorCase", { errorCaseId: id })
        },
        async saveErrorCaseComment(errorCase: IErrorCaseVm): Promise<IErrorCaseVm> {
            return await Http.post<any, IErrorCaseVm>("IssuingAuthority/ErrorCase/SaveErrorCaseComment", { errorCaseId: errorCase.id, Comment: errorCase.comment })
        },
        downloadBankFile(bankFileId: string) {
            return process.env.SERVER + "IssuingAuthority/ErrorCase/DownloadBankFile?bankFileId=" + bankFileId
        }
    }

    private static async buildApplicationSearchQuery(
        sortProperty: string,
        isSortAsc: boolean,
        pageNumber: number,
        civilRegistrationIdentifier?: string,
        certificateNumber?: string,
        name?: string,
        certificateType?: CertificateType,
        certificateProcessType?: CertificateProcessType,
        applicationStatus?: ApplicationStatusType,
        isApplicationSubmittetByEducationalInstitution?: ApplicationSubmitStatusType,
        isApplicationSubmittetByCitizen?: ApplicationSubmitStatusType,
        invoiceNumber?: string,
        educationalInstitutionId?: string,
        teamId?: string,
        companyId?: string,
        applicationEventType?: ApplicationEventType,
        applicationEventTypeDateFrom?: string,
        applicationEventTypeDateTo?: string,
    ) {

        let queryStringParams = "take=20&pageNumber=" + pageNumber + "&sortProperty=" + sortProperty + "&isSortAsc=" + isSortAsc

        if (civilRegistrationIdentifier) {
            civilRegistrationIdentifier = civilRegistrationIdentifier.replace(/_/g, "").replace("-", "")
            queryStringParams += "&civilRegistrationIdentifier=" + civilRegistrationIdentifier
        }
        if (certificateNumber) {
            queryStringParams += "&certificateNumber=" + certificateNumber
        }
        if (name) {
            queryStringParams += "&name=" + name
        }
        if (invoiceNumber) {
            queryStringParams += "&invoiceNumber=" + invoiceNumber
        }
        if (educationalInstitutionId) {
            queryStringParams += "&educationalInstitutionId=" + educationalInstitutionId
        }
        if (Number(applicationStatus) > 0) {
            queryStringParams += "&applicationStatus=" + Number(applicationStatus)
        }
        if (Number(certificateType) > 0) {
            queryStringParams += "&certificateType=" + Number(certificateType)
        }
        if (Number(certificateProcessType) > 0) {
            let flags: CertificateProcessType
            if (Number(certificateProcessType) === CertificateProcessType.Renewal) {
                flags |= CertificateProcessType.Renewal | CertificateProcessType.RenewalBasedOnExternal
            } else if (Number(certificateProcessType) === CertificateProcessType.Replacement) {
                flags |= CertificateProcessType.Replacement | CertificateProcessType.ReplacementBasedOnExternal
            } else if (Number(certificateProcessType) === CertificateProcessType.Change) {
                flags |= CertificateProcessType.Change | CertificateProcessType.ChangeBasedOnExternal
            } else {
                flags |= certificateProcessType
            }

            queryStringParams += "&certificateProcessType=" + Number(flags)
        }

        queryStringParams += "&isApplicationSubmittetByEducationalInstitution=" + isApplicationSubmittetByEducationalInstitution
        queryStringParams += "&isApplicationSubmittetByCitizen=" + isApplicationSubmittetByCitizen

        if (teamId) {
            queryStringParams += "&teamId=" + teamId
        }
        if (companyId) {
            queryStringParams += "&companyId=" + companyId
        }

        if (applicationEventType !== ApplicationEventType.NotSet) {
            queryStringParams += "&applicationEventType=" + applicationEventType
        }

        if (applicationEventTypeDateFrom != null && applicationEventTypeDateFrom.indexOf("_") === -1 && this.isValidDate(applicationEventTypeDateFrom)) {
            queryStringParams += "&applicationEventTypeDateFrom=" + applicationEventTypeDateFrom
        }

        if (applicationEventTypeDateTo != null && applicationEventTypeDateTo.indexOf("_") === -1 && this.isValidDate(applicationEventTypeDateTo)) {
            queryStringParams += "&applicationEventTypeDateTo=" + applicationEventTypeDateTo
        }

        return queryStringParams
    }

    private static async buildErrorCaseSearchQuery(sortProperty: string, isSortAsc: boolean, pageNumber: number, errorCaseSearchObject: IErrorCaseSearchObject) {
        let queryStringParams = "take=20&pageNumber=" + pageNumber + "&sortProperty=" + sortProperty + "&isSortAsc=" + isSortAsc

        if (errorCaseSearchObject.errorCaseNumber) {
            queryStringParams += "&errorCaseNumber=" + errorCaseSearchObject.errorCaseNumber
        }

        if (Number(errorCaseSearchObject.certificateType) > 0) {
            queryStringParams += "&certificateType=" + Number(errorCaseSearchObject.certificateType)
        }

        if (errorCaseSearchObject.applicationCertificateNumber) {
            queryStringParams += "&applicationNumber=" + errorCaseSearchObject.applicationCertificateNumber
        }

        if (Number(errorCaseSearchObject.errorCaseType) > 0) {
            queryStringParams += "&errorCaseType=" + errorCaseSearchObject.errorCaseType
        }

        if (errorCaseSearchObject.dateFrom != null && errorCaseSearchObject.dateFrom.indexOf("_") === -1 && this.isValidDate(errorCaseSearchObject.dateFrom)) {
            queryStringParams += "&dateFrom=" + errorCaseSearchObject.dateFrom
        }

        if (errorCaseSearchObject.dateTo != null && errorCaseSearchObject.dateTo.indexOf("_") === -1 && this.isValidDate(errorCaseSearchObject.dateTo)) {
            queryStringParams += "&dateTo=" + errorCaseSearchObject.dateTo
        }

        if (Number(errorCaseSearchObject.errorCaseStatusType) > 0) {
            queryStringParams += "&errorCaseStatusType=" + errorCaseSearchObject.errorCaseStatusType
        }

        return queryStringParams
    }

    private static async buildBulkInvoiceSearchQuery(sortProperty: string, isSortAsc: boolean, pageNumber: number, bulkInvoiceSearchObject: IBulkInvoiceSearchObject) {
        let queryStringParams = "take=20&pageNumber=" + pageNumber + "&sortProperty=" + sortProperty + "&isSortAsc=" + isSortAsc

        if (bulkInvoiceSearchObject.companyRegistrationIdentifier) {
            queryStringParams += "&companyRegistrationIdentifier=" + bulkInvoiceSearchObject.companyRegistrationIdentifier
        }

        if (bulkInvoiceSearchObject.certificateNumber) {
            queryStringParams += "&certificateNumber=" + bulkInvoiceSearchObject.certificateNumber
        }

        if (bulkInvoiceSearchObject.invoiceNumber) {
            queryStringParams += "&invoiceNumber=" + bulkInvoiceSearchObject.invoiceNumber
        }

        if (Number(bulkInvoiceSearchObject.invoiceStatus) > 0) {
            queryStringParams += "&invoiceStatus=" + bulkInvoiceSearchObject.invoiceStatus
        }

        if (Number(bulkInvoiceSearchObject.certificateType) > 0) {
            queryStringParams += "&certificateType=" + bulkInvoiceSearchObject.certificateType
        }

        if (Number(bulkInvoiceSearchObject.bulkPaymentDateSearchType) > 0) {
            queryStringParams += "&bulkPaymentDateSearchType=" + bulkInvoiceSearchObject.bulkPaymentDateSearchType
        }

        if (bulkInvoiceSearchObject.dateFrom != null && bulkInvoiceSearchObject.dateFrom.indexOf("_") === -1 && this.isValidDate(bulkInvoiceSearchObject.dateFrom)) {
            queryStringParams += "&dateFrom=" + bulkInvoiceSearchObject.dateFrom
        }

        if (bulkInvoiceSearchObject.dateTo != null && bulkInvoiceSearchObject.dateTo.indexOf("_") === -1 && this.isValidDate(bulkInvoiceSearchObject.dateTo)) {
            queryStringParams += "&dateTo=" + bulkInvoiceSearchObject.dateTo
        }

        return queryStringParams
    }

    private static async buildApplicationsForBulkPaymentsSearchQuery(sortProperty: string, isSortAsc: boolean, pageNumber: number, bulkInvoiceSearchObject: IBulkInvoiceSearchObject) {
        let queryStringParams = "take=20&pageNumber=" + pageNumber + "&sortProperty=" + sortProperty + "&isSortAsc=" + isSortAsc

        if (bulkInvoiceSearchObject.companyRegistrationIdentifier) {
            queryStringParams += "&companyRegistrationIdentifier=" + bulkInvoiceSearchObject.companyRegistrationIdentifier
        }

        if (bulkInvoiceSearchObject.certificateNumber) {
            queryStringParams += "&certificateNumber=" + bulkInvoiceSearchObject.certificateNumber
        }

        if (Number(bulkInvoiceSearchObject.certificateType) > 0) {
            queryStringParams += "&certificateType=" + bulkInvoiceSearchObject.certificateType
        }

        return queryStringParams
    }

    private static isValidDate = (date: string) => {
        return date === "" ? false : moment(date, "DD-MM-YYYY").isValid
    }
}
